import React from 'react';
import { motion } from 'framer-motion';

const Sitemap: React.FC = () => {
  const sitemapSections = [
    {
      title: 'Main Pages',
      icon: '🏠',
      links: [
        { name: 'Home', url: '/', description: 'Main landing page' },
        { name: 'About Us', url: '/about', description: 'Learn about our team and mission' },
      ]
    },
    {
      title: 'Services',
      icon: '⚙️',
      links: [
        { name: 'How We Work', url: '/#diagnose', description: 'Our diagnostic approach' },
        { name: 'Process', url: '/#process', description: 'Our implementation timeline' },
        { name: 'ROI Calculator', url: '/#calculator', description: 'Calculate your potential savings' },
        { name: 'Get Started', url: '/#get-started', description: 'Start your free POC' },
      ]
    },
    {
      title: 'Legal & Policies',
      icon: '📋',
      links: [
        { name: 'Privacy Policy', url: '/legal#privacy', description: 'How we protect your data' },
        { name: 'Terms of Service', url: '/legal#terms', description: 'Our service agreement' },
        { name: 'Cookie Policy', url: '/legal#cookies', description: 'How we use cookies' },
        { name: 'GDPR Compliance', url: '/legal#gdpr', description: 'EU data protection compliance' },
        { name: 'Accessibility', url: '/legal#accessibility', description: 'Our accessibility commitment' },
      ]
    },
    {
      title: 'Information',
      icon: '📊',
      links: [
        { name: 'Sitemap', url: '/sitemap', description: 'Website structure overview' },
        { name: 'Status', url: '/status', description: 'System status and uptime' },
      ]
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden min-h-screen">
      {/* Background gradient */}
      <div className="absolute inset-0 opacity-20" style={{ background: 'radial-gradient(circle at 50% 50%, rgba(99, 102, 241, 0.2), transparent 70%)', filter: 'blur(60px)' }}></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            <span
              style={{
                background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-accent) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Sitemap
            </span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Navigate through all pages and sections of our website
          </p>
        </motion.div>

        {/* Sitemap Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {sitemapSections.map((section, index) => (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="glass p-6 rounded-2xl"
              style={{ background: 'rgba(255, 255, 255, 0.05)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255, 255, 255, 0.1)' }}
            >
              <div className="flex items-center gap-3 mb-6">
                <span className="text-3xl">{section.icon}</span>
                <h2 className="text-2xl font-bold text-white">{section.title}</h2>
              </div>

              <ul className="space-y-4">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.url}
                      className="block group"
                    >
                      <div className="flex items-start gap-3 p-3 rounded-lg transition-all duration-300 hover:bg-white/5">
                        <span className="text-blue-400 mt-1">→</span>
                        <div className="flex-1">
                          <h3 className="font-semibold text-white group-hover:text-[var(--color-primary)] transition-colors">
                            {link.name}
                          </h3>
                          <p className="text-sm text-gray-400 mt-1">{link.description}</p>
                        </div>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

      
      </div>
    </section>
  );
};

export default Sitemap;
